import $ from 'jquery';
import { setCookie } from './shared/cookieHelper';

$(function () {

    if ($('#brand_home_page').length) {
        setTimeout(() => {
            $('#brand_home_page .filter').css('width', '100%');
        }, 250);
    }
    if ($('#brand_home_page').length) {

       
        if ($('#languageDropdown').length) {
          
            document.getElementById('languageDropdown').addEventListener('change', function () {

                let selectedLanguage = this.options[this.selectedIndex].dataset.langCode;
                lzSwitchLanguage(selectedLanguage);
            });
        }
        if ($('#languageDropdownmob').length) {
            document.getElementById('languageDropdownmob').addEventListener('change', function () {
                let selectedLanguage = this.options[this.selectedIndex].dataset.langCode;
                lzSwitchLanguage(selectedLanguage);
            });
        }
    }
});